// URL helpers for values that come from the API or from scraped/candidate data.

// Only http(s) links may be rendered as hrefs; anything else (javascript:, data:)
// becomes undefined so the link does nothing.
export const safeHttpUrl = (value) => {
  try {
    const url = new URL(String(value || ""), window.location.origin);
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : undefined;
  } catch {
    return undefined;
  }
};

// The mailbox-connect flow must only ever send the user to Google's sign-in page.
const OAUTH_HOSTS = new Set(["accounts.google.com"]);

export const redirectToOAuth = (value) => {
  let url;
  try {
    url = new URL(String(value || ""));
  } catch {
    throw new Error("Invalid sign-in URL");
  }
  if (url.protocol !== "https:" || !OAUTH_HOSTS.has(url.hostname)) {
    throw new Error("Unexpected sign-in URL");
  }
  window.location.href = url.href;
};

// Escape text before placing it inside HTML that is written with document.write.
export const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Deep copy of a record with every string HTML-escaped, for HTML templates.
export const escapeHtmlDeep = (value) => {
  if (typeof value === "string") return escapeHtml(value);
  if (Array.isArray(value)) return value.map(escapeHtmlDeep);
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, escapeHtmlDeep(v)]));
  }
  return value;
};
